import { useQuery } from '@tanstack/react-query';
import { getStatsDashboard } from '@/lib/coloc-api/admin';
import { useStatsFiltersContext } from './use-stats-filters';

export const useGetStatsData = () => {
  const { startDate, endDate, cityId, selectedHouse, propertyManagerId, selectedOwner } = useStatsFiltersContext();

  return useQuery({
    queryKey: ['statsDashboard', startDate, endDate, cityId, selectedHouse?.id, propertyManagerId, selectedOwner?.id],
    queryFn: () =>
      getStatsDashboard({
        from: startDate,
        to: endDate,
        city_id: cityId,
        colocation_id: selectedHouse?.id?.toString() || null,
        property_manager_id: propertyManagerId,
        owner_id: selectedOwner?.id?.toString() || null
      }),
  });
};
